export const DoppeActionTypeOutfitViewerLang = {
    defaultTexts: {
        productTitle: 'Item Name',
        description: 'Describe the item you want to sell',
        productButtonText: 'Buy Now',
        price: '10$',
        outfitTitle: 'Outfit Items',
    }
}